import { useState } from "react";

const REGIONS = ["All", "Europe", "Oceania", "North America", "Asia"];

const FARMS = [
  {
    name: "Alpine Blossom Farm",
    region: "Europe",
    country: "Switzerland · Bernese Oberland",
    herd: 1650,
    yield: "331L/day/head",
    tag: "Organic Certified",
    img:
      "https://readdy.ai/api/search-image?query=A%20picturesque%20swiss%20alpine%20dairy%20farm%20with%20traditional%20wooden%20chalet%20barn%2C%20holstein%20cows%20grazing%20on%20green%20mountain%20pasture%2C%20snow%20capped%20alps%20in%20the%20background%2C%20wildflowers%2C%20wooden%20fences%2C%20soft%20golden%20hour%20light%2C%20highly%20detailed%20warm%20editorial%20farm%20photography%2C%20cream%20and%20green%20color%20palette%2C%20cinematic%20wide%20composition&width=1000&height=1200&seq=vef-farm-swiss-01&orientation=portrait",
  },
  {
    name: "Sunfield Pasture",
    region: "Oceania",
    country: "New Zealand · Waikato",
    herd: 3526,
    yield: "1428L/day/head",
    tag: "Free Range",
    img:
      "https://readdy.ai/api/search-image?query=A%20vast%20rolling%20green%20new%20zealand%20dairy%20pasture%20with%20black%20and%20white%20holstein%20cows%20freely%20grazing%2C%20clear%20blue%20warm%20sky%2C%20wooden%20farm%20gate%2C%20soft%20natural%20sunlight%2C%20warm%20amber%20highlights%2C%20cinematic%20wide%20landscape%20photography%2C%20editorial%20magazine%20style%2C%20cream%20and%20green%20muted%20color%20tones&width=1000&height=1200&seq=vef-farm-nz-01&orientation=portrait",
  },
  {
    name: "Nordic Green Dairy",
    region: "Europe",
    country: "Denmark · Jutland",
    herd: 1820,
    yield: "533L/day/head",
    tag: "Low-Carbon",
    img:
      "https://readdy.ai/api/search-image?query=A%20modern%20scandinavian%20dairy%20farm%20with%20clean%20white%20wooden%20barns%2C%20green%20fields%20surrounded%20by%20birch%20trees%2C%20holstein%20cows%20on%20soft%20morning%20light%2C%20misty%20fresh%20air%2C%20minimalist%20farm%20architecture%2C%20warm%20cream%20tones%2C%20editorial%20nordic%20photography%2C%20cinematic%20quiet%20atmosphere&width=1000&height=1200&seq=vef-farm-denmark-01&orientation=portrait",
  },
  {
    name: "Golden Valley Dairy",
    region: "North America",
    country: "Canada · Ontario",
    herd: 3562,
    yield: "730L/day/head",
    tag: "Automated Milking",
    img:
      "https://readdy.ai/api/search-image?query=A%20golden%20autumn%20canadian%20dairy%20farm%20with%20red%20wooden%20barn%2C%20fields%20of%20golden%20wheat%20surrounding%20green%20pasture%2C%20black%20and%20white%20dairy%20cows%2C%20warm%20golden%20sunset%20light%2C%20wooden%20silos%2C%20cozy%20rural%20atmosphere%2C%20cinematic%20editorial%20farm%20photography%2C%20warm%20amber%20cream%20color%20palette&width=1000&height=1200&seq=vef-farm-canada-01&orientation=portrait",
  },
  {
    name: "Highland Meadow Co.",
    region: "Asia",
    country: "Japan · Hokkaido",
    herd: 2436,
    yield: "627L/day/head",
    tag: "Alpine Pasture",
    img:
      "https://readdy.ai/api/search-image?query=A%20serene%20hokkaido%20japan%20dairy%20farm%20with%20wide%20green%20rolling%20hills%2C%20a%20single%20wooden%20farmhouse%2C%20cows%20quietly%20resting%2C%20soft%20mist%20over%20the%20fields%2C%20warm%20muted%20natural%20light%2C%20wooden%20fences%2C%20highly%20detailed%20editorial%20farm%20photography%2C%20cream%20green%20warm%20color%20palette%2C%20cinematic%20calm%20mood&width=1000&height=1200&seq=vef-farm-hokkaido-01&orientation=portrait",
  },
  {
    name: "Willowbrook Ranch",
    region: "North America",
    country: "USA · Vermont",
    herd: 2563,
    yield: "539L/day/head",
    tag: "Family Farm",
    img:
      "https://readdy.ai/api/search-image?query=A%20cozy%20vermont%20family%20dairy%20farm%20with%20classic%20red%20barn%20surrounded%20by%20autumn%20maple%20trees%2C%20green%20meadows%20with%20holstein%20cows%2C%20wooden%20fences%2C%20warm%20late%20afternoon%20sunlight%2C%20cinematic%20editorial%20farm%20photography%2C%20warm%20cream%20amber%20green%20tones%2C%20highly%20detailed%20nostalgic%20atmosphere&width=1000&height=1200&seq=vef-farm-vermont-01&orientation=portrait",
  },
];

export default function Farms() {
  const [active, setActive] = useState("All");
  const list = active === "All" ? FARMS : FARMS.filter((f) => f.region === active);

  return (
    <section id="farms" className="w-full bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold tracking-wide">
              <i className="ri-earth-line"></i>
              Global Partner Farms
            </div>
            <h2
              className="mt-5 text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              58 Carefully Selected Farms, <span className="text-primary-600">Guarded Across 4 Continents</span>
            </h2>
            <p className="mt-5 text-sm md:text-lg text-foreground-700 leading-relaxed">
              Every farm entering the CCF network must pass an 18-point audit covering water source, feed quality, and animal welfare. That is our commitment to every member.
            </p>
          </div>

          <div className="flex flex-wrap gap-1.5 md:gap-2 p-1 rounded-full bg-background-100 border border-background-200">
            {REGIONS.map((r) => (
              <button
                key={r}
                onClick={() => setActive(r)}
                className={[
                  "px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap",
                  active === r
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-600",
                ].join(" ")}
              >
                {r}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((farm) => (
            <article
              key={farm.name}
              className="group relative rounded-2xl overflow-hidden border border-background-200 bg-background-50 cursor-pointer"
            >
              <div className="relative w-full h-64 md:h-80 overflow-hidden">
                <img
                  src={farm.img}
                  alt={`${farm.name} · ${farm.country}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur text-xs font-semibold text-foreground-800">
                  <i className="ri-map-pin-line mr-1 text-primary-600"></i>
                  {farm.region}
                </div>
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                  {farm.tag}
                </div>
                <div className="absolute bottom-4 left-5 right-5">
                  <div
                    className="text-background-50 text-xl md:text-2xl font-heading font-semibold"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    {farm.name}
                  </div>
                  <div className="text-background-100/85 text-sm">{farm.country}</div>
                </div>
              </div>

              <div className="p-4 md:p-5 flex items-center justify-between">
                <div>
                  <div className="text-xs text-foreground-600">Herd</div>
                  <div className="mt-1 text-lg font-semibold text-foreground-950">
                    {farm.herd} <span className="text-sm text-foreground-600">head</span>
                  </div>
                </div>
                <div>
                  <div className="text-xs text-foreground-600">Daily Yield</div>
                  <div className="mt-1 text-lg font-semibold text-foreground-950">
                    {farm.yield}
                  </div>
                </div>
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-up-line text-lg"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#contact"
            className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-semibold hover:border-primary-500 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Partner Farms
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}